export function useSupportUrl() {
  return 'https://www.facebook.com/share/18cawdrb3f/';
}
